// Compact paid-sticker alert — small corner card, NOT a screen takeover
import { useEffect, useState } from "react";

export default function StickerAlert({ alert }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!alert) return;
    setShow(true);
    const t = setTimeout(() => setShow(false), 3800);
    return () => clearTimeout(t);
  }, [alert]);

  if (!show || !alert) return null;

  return (
    <div className="absolute top-4 right-4 z-20 pointer-events-none max-w-[260px] animate-fade-in-up" data-testid="sticker-alert">
      <div
        className="bg-black/85 backdrop-blur-md border-l-2 p-3 shadow-2xl"
        style={{ borderColor: alert.color, boxShadow: `0 0 24px ${alert.color}40` }}
      >
        <div className="flex items-center gap-3">
          <span className="text-4xl flex-shrink-0" style={{ filter: `drop-shadow(0 0 10px ${alert.color})` }}>{alert.emoji}</span>
          <div className="min-w-0 flex-1">
            <div className="text-[10px] font-display font-bold tracking-[0.24em] uppercase truncate" style={{ color: alert.color }}>{alert.name}</div>
            <div className="text-[11px] text-white/80 truncate mt-0.5">
              <span className="text-nexus-cyan">{alert.user_name}</span> · <span className="font-mono">{alert.price} NX</span>
            </div>
            {alert.message && <div className="text-[10px] text-white/50 mt-1 italic truncate">"{alert.message}"</div>}
          </div>
        </div>
      </div>
    </div>
  );
}
